import { AIContext } from 'contexts/AIContext';
import { RuleGroupsContext } from 'contexts/RuleGroupsContext';
import { ScheduledPostContext } from 'contexts/ScheduledPostContext';
import { SessionContext } from 'contexts/SessionContext';
import dayjs from 'dayjs';
import moment from 'moment-timezone';
import React, { useContext } from 'react'
import { getUserTimezone } from 'utils/timezone';

export default function usePublishAtSuggestion() {

  const { getByQueryChat } = useContext(AIContext);
  const { scheduledPosts } = useContext(ScheduledPostContext);
  const { autoscheduledPosts } = useContext(RuleGroupsContext);
  const { user } = useContext(SessionContext);

  const getAiSuggestedDateTime = async (postCopy) => {

    let nextPostsDateTimes = [...(scheduledPosts || []), ...(autoscheduledPosts || [])]?.filter(e => !!e?.publish_at)?.map(e => e?.publish_at);
    nextPostsDateTimes.push(`${dayjs().format('YYYY-MM-DDTHH')}:00:00.000000Z`);
    nextPostsDateTimes = nextPostsDateTimes.filter(datetime => new Date(datetime) >= dayjs().subtract(1, 'day').toDate());
    nextPostsDateTimes.sort((a,b) => new Date(a) - new Date(b));
    nextPostsDateTimes = [...new Set(nextPostsDateTimes)];

    let blockedDates = (nextPostsDateTimes || []).map(e => dayjs(e).format("YYYY-MM-DD")).reduce((a, c) => (a[c] = (a[c] || 0) + 1, a), Object.create(null));
    blockedDates = Object.entries(blockedDates).filter(e => e[1] >= 2).map(e => e[0]);

    nextPostsDateTimes = nextPostsDateTimes.filter(e => !blockedDates.includes(dayjs(e).format("YYYY-MM-DD")));

    const tz = getUserTimezone(user);
    const offset = moment.tz(tz).utcOffset() / 60;


// Blocked time ranges where other social media posts are being published:
// ${nextPostsDateTimes?.map(e => `Blocked from: ${dayjs(e).subtract(3, 'hour').toDate().toUTCString()} to: ${dayjs(e).add(3, 'hour').toDate().toUTCString()}`).join("\n")}
    
    const system = `
Today is ${dayjs(new Date()).format("YYYY-MM-DD")}.

Blocked dates:
${blockedDates?.join("\n")}

Datetimes where other social media posts are being published, can't overlap with these:
${nextPostsDateTimes?.join("\n")}

When you receive a social post copy, you must answer with a date and time to publish the given post.
Pick a time of the day with social media engagement, probably from ${10-offset}:00 to ${20-offset}:00 UTC.

The chosen datetime must not be near any of the blocked datetimes.

You must pick only dates in the future. Past dates are not allowed. If it's a social media post about a holiday that comes before ${dayjs(new Date()).format("MMM-DD")}, then pick a date from year ${dayjs(new Date()).add(1, 'year').format("YYYY")}.

Just answer an ISO format date and a 20-word explanation in a separate paragraph.

No preambles. 
    `;
    const prompt = `Twitter post: "${postCopy}"`
    
    const response = await getByQueryChat(prompt, false, true, system, undefined, { temperature: 0, top_p: 0 });

    let parts;
    try {
      parts = response?.split("\n").filter(e => !!e);
      parts = parts.filter(e => !!e?.trim());
    } catch (err) {}

    let date = new Date(parts?.[0]?.trim());
    if (date < dayjs().subtract(1, 'day').toDate()) date = dayjs(date).add(1, 'year').toDate();
    if (date > dayjs().add(1, 'year').toDate()) date = dayjs(date).subtract(1, 'year').toDate();

    return {
      date: moment(date).utc().toISOString(),
      explanation: parts?.[1] || ""
    }
  }

  return {
    getAiSuggestedDateTime
  }
}
